import { render } from "./MyPrivacy.vue?vue&type=template&id=53e2f460&ts=true"
import script from "./MyPrivacy.vue?vue&type=script&lang=ts"
export * from "./MyPrivacy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__